import { useQuery } from '@tanstack/react-query';
import { fetchFacilityProcessOptions } from '@/api/dropdowns';
import type { FilterOption } from '@/api/orders/types';

async function fetchFacilityProcessesOptions(): Promise<FilterOption[]> {
  const res = await fetchFacilityProcessOptions();
  const options: FilterOption[] = [];
  for (const group of res?.facilities ?? []) {
    for (const child of group.children) {
      options.push({ key: child.key, label: child.text });
    }
  }
  return options;
}

export const facilityProcessesQueryOptions = {
  queryKey: ['network', 'filter-options', 'facility-processes'] as const,
  queryFn: fetchFacilityProcessesOptions,
  staleTime: 5 * 60 * 1000,
};

export function useFacilityProcesses() {
  const { data } = useQuery(facilityProcessesQueryOptions);

  const processes = data ?? [];

  function resolveLabel(id: string): string {
    return processes.find(o => o.key === id)?.label ?? id;
  }

  return { processes, resolveLabel };
}
